import React, { useContext, useEffect, useRef } from 'react';
import { Container } from 'reactstrap';
import AuthContext from '../../context/auth/authContext';
import AlertContext from '../../context/alert/alertContext';

// One-click portfolio demo entry point.
//
// Visitors land here from "Try Demo" with no credentials, no forms, and no
// decisions. We log them into the seeded demo account and drop them
// straight onto the populated dashboard.
const TryDemo = (props) => {
  const authContext = useContext(AuthContext);
  const alertContext = useContext(AlertContext);
  const { loginDemo, isAuthenticated, error, clearErrors } = authContext;
  const { setAlert } = alertContext;
  const requested = useRef(false);

  useEffect(() => {
    if (!requested.current) {
      requested.current = true;
      loginDemo();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      props.history.push('/vaccines');
    }

    if (error) {
      setAlert('Demo login is temporarily unavailable.', 'danger');
      clearErrors();
      props.history.push('/login');
    }
    // eslint-disable-next-line
  }, [isAuthenticated, error, props.history]);

  return (
    <Container className="text-center my-5">
      <p className="text-muted">Loading the VacTrac demo…</p>
    </Container>
  );
};

export default TryDemo;
